import "core-js/stable";
import "regenerator-runtime/runtime";
import { async } from "regenerator-runtime";
import * as model from "./model.js";
import locationView from "./views/locationView.js";
import searchView from "./views/searchView.js";
import weatherView from "./views/weatherView.js";
import dayView from "./views/dayView.js";
import hoursView from "./views/hoursView.js";

const submit = document.getElementById("submit");

// <svg class="btn-icon" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><style>.spinner_P7sC{transform-origin:center;animation:spinner_svv2 .75s infinite linear}@keyframes spinner_svv2{100%{transform:rotate(360deg)}}</style><path d="M10.14,1.16a11,11,0,0,0-9,8.92A1.59,1.59,0,0,0,2.46,12,1.52,1.52,0,0,0,4.11,10.7a8,8,0,0,1,6.66-6.61A1.42,1.42,0,0,0,12,2.69h0A1.57,1.57,0,0,0,10.14,1.16Z" class="spinner_P7sC"/></svg>

const init = async function () {
  try {
    //2 Init autocomplete

    model.state.searchBar = searchView.searchBar; //assigns the search bar element to the state
    await model.initAutocomplete(); // loads the autocomplete google service
    await model.autocomplete.addListener("place_changed", getLocationClick); // Adds listener to the model
    searchView.addKeyPressHandler(keyPress); // Adds search funcntionality
    searchView.addHandlerClear(clearSearch); // Adds serach functionality
    checkSearchBar(); // Init the checkSearch bar. / Constantly checks for changes to search bar to update UI
    searchView.addHandlerBookmarkIcon();
    searchView.addHandlerBookmarkList(selectBookmark);
    await model.initPlaces();
    searchView.addDocumentListener();
  } catch (err) {
    console.error(err);
    throw err;
  }
};

const getLocationClick = async function () {
  try {
    await model.onPlaceClick(); //The main function in the model that inits the search

    // console.log(model.state);
    searchView.renderSpinner(); //renders a loading spinner
    //State changes
    if (model.state.dataLoaded) {
      render();
    }
  } catch (err) {
    console.error(err);
    throw err;
  }
};

const render = function () {
  model.state.searchIcon = "spin";
  model.state.loading = true;
  model.state.tempUnit = "celcius";
  checkBookmark();
  locationView.render(model.state);
  //Render to page
  weatherView.render(model.state);
  weatherView.addHandlerChangeTemp(changeTemp);
  weatherView.renderWeatherDetails();
  locationView.addImgLoadHandler(imgLoad);
  //Render Days
  dayView.render(model.state);
  dayView.addActiveClass();
  hoursView.render(model.state);
  dayView.addHandlerChangeForcast(changeDayForcast);
  dayView.addHandlerClick(controlDays);
  dayView.addHandlerButtonRight();
  dayView.addHandlerButtonLeft();
  hoursView.addHandlerButtonRight();
  hoursView.addHandlerButtonLeft();
  locationView.addHandlerBookmark(addBookmark);
};

const changeDayForcast = function () {
  controlDays(0);
  dayView.render(model.state);
  dayView.addActiveClass();
};

const checkSearchBar = function () {
  setTimeout(() => {
    if (!model.state.loading) {
      if (
        searchView.searchBar.value === "" &&
        model.state.searchIcon === "search"
      ) {
        searchView.renderSearchIcon();
        model.state.searchIcon = "empty"; // completely stops the function.
        return;
      } else {
        if (model.state.searchIcon === "clear") {
          model.state.searchIcon = "clear";
          searchView.renderCloseIcon();
        }
      }
    }
    checkSearchBar();
  }, 400);
};

const keyPress = function () {
  if (!searchView.searchBar.value) {
    model.state.searchIcon = "search";
    searchView.renderCloseIcon();
  }
  checkSearchBar(); // restart checkSearch everytime key pressed.
};

const clearSearch = function () {
  searchView.searchBar.value = "";
  model.state.searchIcon = "search";
  searchView.renderSearchIcon();
  searchView.searchBar.focus();
};

const imgLoad = function () {
  checkSearchBar();
  model.state.searchIcon = "search";
  model.state.loading = false;
  locationView.displayImg();
  searchView.renderCloseIcon();
};

const changeTemp = function () {
  model.state.tempUnit === "celcius"
    ? (model.state.tempUnit = "farenheight")
    : (model.state.tempUnit = "celcius");
  weatherView.render(model.state);
  weatherView.addHandlerChangeTemp(changeTemp);
  weatherView.renderTempUnit();
  weatherView.renderWeatherDetails();
  dayView.render(model.state);
  hoursView.render(model.state);
};

const controlDays = function (currentDay) {
  model.state.day = Number(currentDay);

  //render hours
  hoursView.render(model.state);
};

const addBookmark = function () {
  let duplicate = false;

  model.state.bookmarks.forEach((bookmark) => {
    if (Object.values(bookmark).includes(model.state.data.placeId)) {
      console.log("duplicate");
      duplicate = true;
      const index = model.state.bookmarks.findIndex((bookmark) =>
        Object.values(bookmark).includes(model.state.data.placeId)
      );
      model.state.bookmarks.splice(index, 1);
      console.log(model.state.bookmarks);
      model.state.booked = false;
      locationView.renderBookmark();
      searchView.render(model.state);

      console.log("Bookmark removed");
    }
  });

  if (duplicate === true) {
    return;
  }

  model.state.bookmarks.push({
    placeName: model.state.data.placeName,
    placeId: model.state.data.placeId,
  });
  model.state.booked = true;
  locationView.renderBookmark();
  console.log("bookmark added");
  console.log(model.state.bookmarks);
  searchView.render(model.state);
};

const checkBookmark = function () {
  const index = model.state.bookmarks.findIndex((bookmark) =>
    Object.values(bookmark).includes(model.state.data.placeId)
  );
  if (index === -1) {
    // -1 is returned is there is nothing found in the bookmarks array
    model.state.booked = false;
    return;
  }

  if (model.state.bookmarks[index].placeId === model.state.data.placeId) {
    console.log("bookmarked");
    model.state.booked = true;
  }

  // locationView.addImgLoadHandler(imgLoad);
};

const selectBookmark = function (selectedBookmark) {
  const placeId = model.state.bookmarks[selectedBookmark].placeId;
  console.log(placeId);
  model.initPlaces(placeId);
};

window.addEventListener("State_Loaded", function () {
  render();
});

init();
